<template>
  <b-table v-bind="tableAttributes" :items="items" :fields="fields">

    <template #cell(id)="data">
      <span class="text-wrap">{{ data.item.id }}</span>
    </template>

    <template #cell(image)="data">
      <img class="multiple-store-image" :src="data.item.image" alt="">
    </template>

    <template #cell(name)="data">
      <span class="text-wrap">{{ data.item.name }}</span>
    </template>

    <template #cell(cellphone)="data">
      <a class="text-decoration-none" :href="`tel:${data.item.cellphone}`">{{ data.item.cellphone }}</a>
    </template>


    <template #cell(action)="data" v-if="isAdmin">


      <span class="h5" v-b-tooltip.hover title="محصولات">
          <router-link target="_blank"
                       :to="{ name: 'ProductsDashboard', query: { multiple_store: data.item.id } }">
            <b-icon icon="card-list" class="mr-3"></b-icon>
          </router-link>
        </span>

      <span class="h5" v-b-tooltip.hover title="سفارشات">
          <router-link target="_blank"
                       :to="{ name: 'Orders', query: { multiple_store: data.item.id } }">
            <b-icon icon="cart-check-fill" class="mr-3"></b-icon>
          </router-link>
        </span>
    </template>


  </b-table>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "tableItemOfOrders",
  components: {},
  props: ["items", "restoreState"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "id", label: "شناسه فروشگاه"},
        {key: "image", label: "تصویر"},
        {key: "name", label: "نام"},
        {key: "cellphone", label: "شماره تلفن"},
        {key: "action", label: ""}
      ],
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: 'User/isAdmin'
    })
  },
  methods: {
    formatNumber,
    dateConverter,
  },

};
</script>

<style scoped>
.multiple-store-image {
  height: 150px;
  width: 150px;
}

</style>